import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Chemistry"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.4233 17.7135L15 10.2563V3H16.5V1.5H7.50003V3H9.00003V10.2563L3.57678 17.7135C2.90976 18.6302 2.81369 19.8437 3.32816 20.854C3.84263 21.8643 4.88057 22.5003 6.01428 22.5H17.985C19.1187 22.5003 20.1567 21.8643 20.6712 20.854C21.1856 19.8437 21.0896 18.6302 20.4225 17.7135H20.4233ZM10.5 10.7437V3H13.5V10.7437L15.5048 13.5H8.49526L10.5 10.7437ZM17.9858 21H6.0151C5.44591 20.9994 4.9251 20.6798 4.66676 20.1726C4.40843 19.6654 4.45616 19.0563 4.79035 18.5955L7.40485 15H16.5953L19.2106 18.5955C19.5448 19.0563 19.5925 19.6654 19.3342 20.1726C19.0758 20.6798 18.555 20.9994 17.9858 21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Chemistry.vue"]]);
